import { ManfrediteLinkedinProfileAuthCallbackResponse } from './manfredite-linkedin-profile-auth-callback.response';
export const createMockedManfrediteLinkedinProfileAuthCallbackResponse = (customValues = {}) => {
    const response = new ManfrediteLinkedinProfileAuthCallbackResponse();
    response.token = customValues.token ?? '1a8b791f-c8d9-40b3-aabc-bbf6560a00da';
    return response;
};
//# sourceMappingURL=manfredite-linkedin-profile-auth-callback.response.mock.js.map